import {InvoiceFormBaseState} from "features/forms/invoice";
import {createSlice} from "@reduxjs/toolkit";
import {getProfileSuccess} from "store/reducer/user/profile/reducer";
import {ReducerStatuses} from "services/utils/utils";

export const initialState = {
    status: ReducerStatuses.IDLE,
    error: "",
    data: {
        ...InvoiceFormBaseState
    }
}

const slice = createSlice({
    name: "paymentInvoice",
    initialState,
    reducers: {
        setInvoice: (state, {payload}) => {
            state.data = {
                ...state.data,
                ...payload
            }
        },
        saveInvoiceDataStart: (state) => {
            state.status = ReducerStatuses.LOADING;
        },
        saveInvoiceDataFailure: (state, {payload}) => {
            state.status = ReducerStatuses.ERROR;
            state.error = payload;
        },
        saveInvoiceDataSuccess: (state) => {
            state.status = ReducerStatuses.SUCCESS;
        }
    },
    extraReducers: {
        [getProfileSuccess]: (state, {payload}) => {
            state.data = {
                ...state.data,
                ...payload.invoicing
            }
        }
    }
});
const {reducer, actions} = slice;
export const {
    setInvoice, saveInvoiceDataFailure, saveInvoiceDataStart, saveInvoiceDataSuccess
} = actions;
export default reducer;